const welcome = {
    title: 'مرحبًا بك في لوحة التحكم الإدارية',
    description: 'لوحة التحكم الإدارية هي تطبيق ويب لإدارة JX Account بدون متطلبات برمجية. دعنا نقوم أولاً بإنشاء حساب. باستخدام هذا الحساب ، يمكنك إدارة JX Account بنفسك أو نيابة عن شركتك.',
    create_account: 'إنشاء حساب',
};
export default Object.freeze(welcome);
